namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmPostovniSluzbaProZasilky extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmPostovniSluzbaProZasilkyReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmPostovniSluzbaProZasilkyObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmPostovniSluzbaProZasilkyObj());
            this.detailObj.createBase({
                contentName: "detailAdmPostovniSluzbaProZasilky",
                contentCaption: "jres:33000178", //RC 33000178 : Poštovní služba
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmPostovniSluzbaProZasilky", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmPostovniSluzbaProZasilkyObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmPostovniSluzbaProZasilkyReadDto> {

        create() {
            //this.data["gener_automat"] = 1;
        }

        textPopis(): string | undefined | null {
            return this.data["post_sluzba_txt"]
        }

        setSxsDetail(): string {
            return this.data.post_sluzba + "#";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmPostovniSluzbaProZasilkySaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.NewRecord == true) 
                //if (this.cnt.findForms("{0}form".format(this.options.contentName)).findFields("gener_automat").gfield("getValue") == true)
                    data.post_sluzba = null;
            (this.cnt.isl.AdmPostovniSluzbaProZasilky.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmPostovniSluzbaProZasilky", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmPostovniSluzbaProZasilky.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.post_sluzba_txt) ? this.data.post_sluzba_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenSslDenik?.update({ visible: editMode == false })
        }

        createForm() {
            //this.MakeBoolField("gener_automat", {
            //    change: (ev, ctx) => {
            //        var fieldPostSluzba = this.cnt.element.findForms("{0}form".format(this.options.contentName)).findFields("post_sluzba");
            //        if (ctx.value == true) {
            //            fieldPostSluzba.gfield("clear");
            //            fieldPostSluzba.gfield("setValidators", [])
            //            fieldPostSluzba.gfield("disable")
            //        } else {
            //            fieldPostSluzba.gfield("setValidators", [new Gordic.Validators.Required({ stopping: true }), new Gordic.Validators.Range({ min: 10000 })])
            //            fieldPostSluzba.gfield("enable")
            //        }
            //    }
            //});
            this.MakeField("post_sluzba", {
                emptyValue: null,
                defaultValue: 0,
            });
            this.MakeField("post_sluzba_txt");
            this.MakeField("post_sluzba_zkr");
            this.MakeField("post_sluzba_poz");
            this.MakeField("filtr_format");
            this.MakeSelectField("priz_doruc", Gordic.Prefabs.Select.wflcpdo(), { model: "model.priz_doruc=value.priz_doruc" });
            this.MakeSelectField("zpusoby_doruceni", Gordic.Prefabs.Select.wflczpd(), {
                model: function (op, dto, modelOptions) {
                    switch (op) {
                        case "apply":
                            if (dto["zpusoby_doruceni"]) {
                                if (dto["zpusoby_doruceni"].length != 0)
                                    $(this).gfield("setValue", dto["zpusoby_doruceni"].map(obj => ({ zpusob_dor: obj.zpusob_dor })), { valid: false })
                            }
                            return;
                        case "collect":
                            dto["zpusoby_doruceni"] = $(this).gfield("getValue");
                            return;
                    }
                },
                multi: true,
                dropdown: false,
                itemWidth: "",
            })
            this.MakeSelectField("druhy_zasilek", Gordic.Prefabs.Select.wflcdrz(), {
                model: function (op, dto, modelOptions) {
                    switch (op) {
                        case "apply":
                            if (dto["druhy_zasilek"]) {
                                if (dto["druhy_zasilek"].length != 0)
                                    $(this).gfield("setValue", dto["druhy_zasilek"].map(obj => ({ druh_zas: obj.druh_zas }) ), { valid: false })
                            }
                            return;
                        case "collect":
                            dto["druhy_zasilek"] = $(this).gfield("getValue");
                            return;
                    }
                },
                multi: true,
                dropdown: false,
                itemWidth: "",
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}